export default "__VITE_ASSET__6efa5e4e__"